<template>
  <div class="app-container">
    <basic-container>
      <el-form label-position="top" v-if="isLoaded" :rules="rules" ref="ruleForm" :model="courseFrom" size="medium">
        <el-form-item label="课程名称：" prop="name">
          <el-col :span="12">
            <el-input v-model="courseFrom.name"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="课程名称（英文）：" prop="nameEn">
          <el-col :span="12">
            <el-input v-model="courseFrom.nameEn"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="课程介绍：" prop="description">
          <el-col :span="16">
            <rich-text-editor v-model="courseFrom.description" placeholder="输入课程介绍" :ossImageFolder="ossImageFolder" :ossVideoFolder="ossVideoFolder" :ossFileFolder="ossFileFolder"></rich-text-editor>
          </el-col>
        </el-form-item>
        <el-form-item label="课程介绍（英文）：" prop="descriptionEn">
          <el-col :span="16">
            <rich-text-editor v-model="courseFrom.descriptionEn" placeholder="输入课程介绍（英文）" :ossImageFolder="ossImageFolder" :ossVideoFolder="ossVideoFolder" :ossFileFolder="ossFileFolder"></rich-text-editor>
          </el-col>
        </el-form-item>
        <el-form-item label="封面图片：" prop="coverUrl">
          <template slot="label">
            封面图片： <span class="image-upload-tip">(推荐尺寸为328×260像素)</span>
          </template>
          <div v-if="courseFrom.coverUrl" class="course-coverUrl-wrapper">
            <img class="course-list-page-image" :src="courseFrom.coverUrl | ossImageProcess">
            <el-button type="text" @click="courseFrom.coverUrl = ''" icon="icon-remove-image" class="image-remove-icon"></el-button>
          </div>
          <el-button v-else type="text" @click="handleListPageImageChange" icon="icon-add-cover"></el-button>
        </el-form-item>

        <el-form-item label="课程分组：" prop="courseGroupId">
          <el-col :span="12">
          <el-select clearable v-model="courseFrom.courseGroupId" placeholder="选择课程分组">
            <el-option
              v-for="(item, index) in courseGroups"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="课程状态：" prop="status">
          <el-col :span="12">
          <el-select v-model="courseFrom.status" placeholder="选择课程状态">
            <el-option
              v-for="(item, index) in courseStatus"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="课程类型：" prop="courseType">
          <el-col :span="12">
          <el-select v-model="courseFrom.courseType" placeholder="选择课程类型">
            <el-option
              v-for="(item, index) in courseTypes"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-col>
        </el-form-item>

        <el-form-item v-if="courseFrom.courseType === courseTypeEnums.PRIVATE.code" label="可参与用户：" prop="userTagId">
          <el-col :span="12">
          <el-select v-model="courseFrom.userTagId" placeholder="选择可参与学习用户标签" filterable>
              <el-option
                v-for="(item, index) in enrollScopeList"
                :key="index"
                :label="item.tagName"
                :value="item.id">
            </el-option>
          </el-select>
          </el-col>
        </el-form-item>

        <el-form-item :error="lecturerErrorMsg" label="课程讲师：">
          <el-col :span="15">
            <el-radio @change="resetLecturerMsg" v-model="currentLecturerType" :label="true">内部员工</el-radio>
            <el-radio @change="resetLecturerMsg" v-model="currentLecturerType" :label="false">其他</el-radio>
          </el-col>
          <el-col v-if="!currentLecturerType" :span="15">
            <el-input v-model="courseFrom.lecturer" maxlength="512"></el-input>
          </el-col>
          <el-col v-if="currentLecturerType" :span="15">
            <el-tag
              v-for="lecturer in currentSelectLecturers"
              :key="lecturer.unionId"
              closable
              @close="handleLecturerRemove(lecturer)">
              {{lecturer.nickname}}
            </el-tag>
            <el-popover
              width="340"
              placement="bottom-start"
              trigger="click"
              @hide="resetSelectLecturer"
              v-model="isShowPopover"
              v-clickoutside="hiddenSelectTree">
              <el-input
                v-model="lecturerSearch"
                clearable
                @clear="handleClearLecturer"
                @input="resetSelectTree"
                @keyup.enter.native="searchLecturerList"
                class="lecture-input"
                placeholder="搜索课程讲师关键字">
              </el-input>
              <el-button class="lecturer-btn" type="primary" @click="searchLecturerList" icon="el-icon-search"></el-button>
              <el-tree v-show="isShowSelect"
                      empty-text="无数据"
                      :highlight-current = true
                      :default-expand-all = false
                      :check-on-click-node= true
                      :expand-on-click-node="false"
                      :data="lecturers"
                      :props="lecturerProps"
                      @node-click="getCheckedNodes"
                      class="lecturerTree">
              </el-tree>
              <el-button class="lecturer-btn" type="primary" slot="reference" icon="el-icon-plus" circle @click="resetLecturerMsg"></el-button>
            </el-popover>
          </el-col>
        </el-form-item>

        <el-form-item label="排序" prop="sort">
          <el-col :span="12">
            <el-input-number controls-position="right" v-model="courseFrom.sort" :precision="0"></el-input-number>
            <span class="tips-info" >【提示：数字越大优先级越高】</span>
          </el-col>
        </el-form-item>

        <el-form-item label="建议学习时长" prop="courseTime">
          <el-col :span="22">
            <template>
              <el-input-number controls-position="right" v-model="courseFrom.courseTimeDay" :step="1" :min="0" :controls="false" @blur="handleCourseTimeBlur" size="small" v-input-int></el-input-number><span class="time-unit"> 天 </span>
              <el-input-number controls-position="right" v-model="courseFrom.courseTimeHour" :step="1" :min="0"  :max="24*60" :controls="false" @blur="handleCourseTimeBlur" size="small" v-input-int></el-input-number><span class="time-unit"> 小时 </span>
              <el-input-number controls-position="right" v-model="courseFrom.courseTimeMinute" :step="1" :min="0"  :max="59" :controls="false" @blur="handleCourseTimeBlur" size="small" v-input-int></el-input-number><span class="time-unit"> 分 </span>
            </template>
          </el-col>
        </el-form-item>

        <el-form-item label="课程互动积分">
          <el-row>
            <el-col :span="8">
              <span>每次点赞积分：</span>
              <el-input-number controls-position="right" v-model="courseFrom.likeRewardValue" :step="1" :min="0" v-input-int></el-input-number>
            </el-col>
            <el-col :span="8">
              <span>每日上限：</span>
              <el-input-number controls-position="right" v-model="courseFrom.likeDailyLimit" :step="1" :min="0" v-input-int></el-input-number>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <span>每次评论积分：</span>
              <el-input-number controls-position="right" v-model="courseFrom.commentRewardValue" :step="1" :min="0" v-input-int></el-input-number>
            </el-col>
            <el-col :span="8">
              <span>每日上限：</span>
              <el-input-number controls-position="right" v-model="courseFrom.commentDailyLimit" :step="1" :min="0" v-input-int></el-input-number>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="积分发放起止时间" prop="courseFrom.rewardValueStartEndTime">
          <el-col :span="12">
            <el-date-picker
              :default-time="['00:00:00', '23:59:00']"
              v-model="courseFrom.rewardValueStartEndTime"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始时间"
              end-placeholder="结束时间">
            </el-date-picker>
          </el-col>
        </el-form-item>

        <!-- <el-form-item label="是否关联考试：">
          <el-switch v-model="courseFrom.isRelevanceExam"></el-switch>
        </el-form-item>

        <el-form-item v-if="courseFrom.isRelevanceExam" label="关联考试：" prop="examId">
          <el-col>
            <div v-if="courseFrom.examId" style="display:flex">
              <span>
                {{ courseFrom.examName }}
              </span>
              <el-button
                type="text"
                icon="icon-remove-image"
                @click="removeExamSelected"
              />
            </div>
            <el-button
              v-else
              type="text"
              icon="icon-add-cover"
              @click="showExamSelector = true"
            />
          </el-col>
        </el-form-item>

        <el-form-item v-if="courseFrom.isRelevanceExam" label="考试截止时间" prop="examEndTime">
          <el-col :span="12">
            <el-date-picker
              v-model="courseFrom.examEndTime"
              type="datetime"
              placeholder="选择日期时间">
            </el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item v-if="courseFrom.isRelevanceExam" label="参与考试条件：" prop="examCondition">
          <el-col :span="12">
          <el-select v-model="courseFrom.examCondition" placeholder="选择参与考试条件">
            <el-option
              v-for="(item, index) in examConditions"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-col>
        </el-form-item>

        <el-form-item v-if="courseFrom.isRelevanceExam" label="课程完成条件：" prop="passCondition">
          <el-col :span="12">
          <el-select v-model="courseFrom.passCondition" placeholder="选择课程完成条件">
            <el-option
              v-for="(item, index) in passConditions"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="是否关联证书：">
          <el-switch v-model="courseFrom.isRelevanceCert"></el-switch>
        </el-form-item>

        <el-form-item v-if="courseFrom.isRelevanceCert" label="关联证书【课程完成后发放】：" prop="certId">
          <el-col>
            <div v-if="courseFrom.certId" style="display:flex">
              <span>
                {{ courseFrom.certName }}
              </span>
              <el-button
                type="text"
                icon="icon-remove-image"
                @click="removeCertSelected"
              />
            </div>
            <el-button
              v-else
              type="text"
              icon="icon-add-cover"
              @click="showCertSelector = true"
            />
          </el-col>
        </el-form-item> -->

        <div class="operation">
          <el-button @click="$router.go(-1)" size="medium">取消</el-button>
          <el-button type="primary" @click="handleSavaCourse" size="medium">保存</el-button>
        </div>
      </el-form>
    </basic-container>
    <exam-selector v-if="showExamSelector" :dialogVisible="showExamSelector" @close="showExamSelector=false" @confirm-select="handleSelectExam"/>
    <cert-selector v-if="showCertSelector" :dialogVisible="showCertSelector" @close="showCertSelector=false" @confirm-select="handleSelectCert"/>
  </div>
</template>

<script>
import {getEnrollScopeList, getCourseById, createCourse, editCourse} from '@/api/app/course';
import {statusTypeOptions, courseTypeOptions, examConditions, passConditions, courseTypeEnums, courseStatusEnums, courseGroupOptions} from '@/const/crud/app/course';
import RichTextEditor from '@/components/rich-text-editor/index.vue';
import ExamSelector from './components/ExamSelector.vue';
import CertSelector from './components/CertSelector.vue';
import { convertTimeStructure } from '../courseware/util/index';
import { getMembersByNickname } from '@/api/admin/member';
import { getOSSCourse, getOSSVideoCourse, getOSSFileCourse } from '@/api/basic/aliyunoss';
import moment from 'moment';

export default {
  components: {
  },
  data() {
    return {
      isLoaded: false,
      courseFrom: {
        name: '',
        nameEn: '',
        description:'',
        descriptionEn:'',
        coverUrl: '',
        status: courseStatusEnums.INACTIVE.code,
        courseType: courseTypeEnums.PUBLIC.code,
        userTagId: undefined,
        examType: 1,
        examId: undefined,
        courseGroupId: undefined,
        sort: 0,
        lecturer: '',
        courseTimeDay: undefined,
        courseTimeHour: undefined,
        courseTimeMinute: undefined,
        courseTime: undefined,
        isRelevanceExam: false,
        examId: undefined,
        examName: '',
        examCondition: 1,
        examEndTime: '',
        passCondition: 1,
        isRelevanceCert: false,
        certId: undefined,
        certName: '',
        courseLecturers: [], 
        likeRewardValue: 0,
        likeDailyLimit: 0,
        commentRewardValue: 0,
        commentDailyLimit: 0,
        rewardValueStartEndTime: '',
      },
      rules: {
        name: [
          { required: true, message: '课程名称不能为空', trigger: 'blur' },
        ],
        nameEn: [
          { required: true, message: '课程名称英文不能为空', trigger: 'blur' },
        ],
        description: [
          { required: true, message: "课程介绍不能为空" },
        ],
        descriptionEn: [
          { required: true, message: "课程介绍英文不能为空" },
        ],
        coverUrl: [
          { required: true, message: "请选择活动列表页图片", trigger: 'blur' },
        ],
        userTagId: [
          { required: true, message: '可参与用户不能为空', trigger: 'blur' },
        ],
        sort: [
          { required: true, message: "请填写排序级别", trigger: 'blur' },
        ],
        examId: [
          { required: true, message: "请关联考试", trigger: 'blur' },
        ],
        courseTime: [
          { required: true, message: '请填写课件建议学习时长', trigger: 'blur' },
        ],
        certId: [
          { required: true, message: "请关联证书", trigger: 'blur' },
        ],
      },
      courseStatus: statusTypeOptions,
      courseTypes: courseTypeOptions,
      courseGroups: courseGroupOptions,
      enrollScopeList: [],
      courseTypeEnums: courseTypeEnums,
      ossImageFolder: getOSSCourse(),
      ossVideoFolder: getOSSVideoCourse(),
      ossFileFolder: getOSSFileCourse(),
      showExamSelector: false,
      showCertSelector: false,
      examConditions: examConditions,
      passConditions: passConditions,
      lecturerProps: {
        label: "value",
      },
      lecturers:[],
      lecturerSearch: '',
      lecturerErrorMsg: '',
      currentSelectLecturers: [],
      isShowSelect: false,
      currentLecturerType: true,
    }
  },
  components: {
    RichTextEditor,
    ExamSelector,
    CertSelector,
  },
  computed: {
  },
  async mounted() {
  },
  async created() {
    this.isEdit = this.$route.path.includes('edit');
    this.id = this.$route.params.id;
    if (this.isEdit && !isNaN(this.id)) {
      this.initDetail();
    } else {
      this.isLoaded = true;
    }
    this.getEnrollScopeList();
  },
  methods: {
    handleListPageImageChange() {
      this.$openMaterialLib((list) => {
        if (list && list.length > 0) {
          this.courseFrom.coverUrl = list[0].contentUrl;
        }
        this.$refs.ruleForm.validateField('coverUrl');
        }, 1);
    },
    getEnrollScopeList() {
      getEnrollScopeList().then(response =>{
        if (response.data.code === 0) {
          this.enrollScopeList = response.data.data;
        } else {
          this.$message.error(response.msg);
        }
      });
    },
    initDetail() {
      getCourseById(this.id).then(response => {
        if (response.data.code === 0) {
          let data = response.data.data;
          this.formatDetail(data);
        } else {
          this.$message({
            message: "无法编辑该课程",
            type: 'error',
          });
        }
        this.isLoaded = true;
      }).catch(error => {
        this.$message({
          message: error,
          type: 'error',
        });
        this.isLoaded = true;
      })
    },
    formatDetail(data) {
      Object.assign(this.courseFrom, data);
      const lengthInfo = convertTimeStructure(data.courseTime);
      this.courseFrom.courseTimeDay = lengthInfo.day;
      this.courseFrom.courseTimeHour = lengthInfo.hour;
      this.courseFrom.courseTimeMinute = lengthInfo.minute;
      if (data.examId) {
        this.courseFrom.isRelevanceExam = true;
      }
      if (data.certId) {
        this.courseFrom.isRelevanceCert = true;
      }
      if (this.courseFrom.lecturer && this.courseFrom.lecturer !== '') {
        this.currentLecturerType = false;
      }
      if (this.currentLecturerType && this.courseFrom.courseLecturers.length !== 0) {
        this.currentSelectLecturers = this.courseFrom.courseLecturers;
      }
      this.courseFrom.rewardValueStartEndTime = 
        data.rewardValueStartTime && data.rewardValueEndTime 
          ? [data.rewardValueStartTime, data.rewardValueEndTime] 
          : '';
      if (!this.enrollScopeList.map(item => item.id).includes(data.userTagId)) {
        this.courseFrom.userTagId = undefined;
      }
    },
    handleSavaCourse() {
      if (this.courseFrom.courseType === courseTypeEnums.PRIVATE.code) {
        this.$refs.ruleForm.validateField('userTagId');
      }
      this.$refs.ruleForm.validate(async (valid, result) => {
        if (this.currentLecturerType) {
          this.courseFrom.lecturer = '';
        } 
        if (this.courseFrom.examEndTime) {
          this.courseFrom.examEndTime = moment(this.courseFrom.examEndTime).format('YYYY-MM-DD HH:mm:ss');
        }
        const params = Object.assign({}, this.courseFrom);
        if (this.isEdit) {
          params.id = this.id;
        }
        if (this.courseFrom.isRelevanceExam === false) {
          params.examId = '';
          params.examName = '';
          params.examCondition = 1;
          params.examEndTime = '';
          params.passCondition = 1;
        }
        if (this.courseFrom.isRelevanceCert === false) {
          params.certId = '';
          params.certName = '';
        }
        params.lecturerList = this.currentLecturerType ? this.currentSelectLecturers : [];
        if (params.rewardValueStartEndTime && params.rewardValueStartEndTime.length > 1) {
          params.rewardValueStartTime = params.rewardValueStartEndTime[0];
          params.rewardValueEndTime = params.rewardValueStartEndTime[1];
        } else {
          params.rewardValueStartTime = '';
          params.rewardValueEndTime = '';
        }
        if (valid) {
          const func = this.isEdit ? editCourse : createCourse;
          func(params).then(response => {
            if (response.data.code === 0) {
              this.$message({
                message: this.isEdit ? '编辑成功' : '创建成功',
                type: 'success',
              });
              this.$router.go(-1);
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error',
              });
            }
          });
        } else {
          this.$message({
            message: result[Object.keys(result)[0]][0].message || '请正确填写课程信息',
            type: 'warning'
          });
          return false;
        }
      });
    },
    handleCourseTimeBlur(event) {
      this.courseFrom.courseTime = this.calculateCourseTime(this.courseFrom.courseTimeDay, this.courseFrom.courseTimeHour, this.courseFrom.courseTimeMinute);
    },
    calculateCourseTime(day, hour, minute) {
      let length = 0;
      if (day) length += day * 86400;
      if (hour) length += hour * 3600;
      if (minute) length += minute * 60;

      return length || undefined;
    },
    removeExamSelected() {
      this.courseFrom.examId = undefined;
      this.courseFrom.examName = '';
      this.$forceUpdate();
    },
    handleSelectExam(selectExam) {
      this.courseFrom.examId = selectExam.id;
      this.courseFrom.examName = selectExam.title;
    },
    removeCertSelected() {
      this.courseFrom.certId = undefined;
      this.courseFrom.certName = '';
      this.$forceUpdate();
    },
    handleSelectCert(selectCert) {
      this.courseFrom.certId = selectCert.id;
      this.courseFrom.certName = selectCert.name;
    },
    resetLecturerMsg() {
      this.lecturerErrorMsg = '';
    },
    handleLecturerRemove(item) {
      this.currentSelectLecturers.splice(this.currentSelectLecturers.indexOf(item), 1);
      if (!this.currentSelectLecturers || this.currentSelectLecturers.length === 0) {
        this.lecturerErrorMsg = '课程讲师不能为空';
      }
      this.resetSelectLecturer();
    },
    getCheckedNodes(node, e) {
      if(this.currentSelectLecturers.length == 0) {
        this.currentSelectLecturers.push(node);
      } else {
        let count = 0;
        this.currentSelectLecturers.forEach(item => {
          item.unionId === node.unionId && item.nickname === node.nickname  ? count++ : count;
        });
        if (count === 0) {
          this.currentSelectLecturers.push(node);
        } else {
          this.$message.warning('已选择该课程讲师');
        }
      }
      this.resetSelectLecturer();
    },
    resetSelectLecturer() {
      this.lecturerSearch = '';
      this.isShowPopover = false;
      this.resetSelectTree();
    },
    searchLecturerList() {
      let _this = this
      let lecturers = []
      let params = {
        nickname: _this.lecturerSearch,
      }
      getMembersByNickname(params).then(response => {
        if (response.status == 200) {
          lecturers = response.data.data
          _this.lecturers = []
          if(lecturers.length === 0) {
            this.$message.warning("未找到相关课程讲师");
          }
          if (lecturers && lecturers.length > 0) {
            setTimeout(() => {
              lecturers.forEach(function(lecturer, index) {
                _this.lecturers.push( {value: lecturer.nickname + '(' + lecturer.unionId + ')', nickname: lecturer.nickname, unionId: lecturer.unionId} )
              })
              this.isShowSelect = true
            }, 150);
          }
        }
      }).catch(err => {
      })
    },
    resetSelectTree() {
      this.lecturers = []
      this.isShowSelect = false
    },
    handleClearLecturer() {
      this.lecturers = []
      this.isShowSelect = false
    },
  }
}
</script>

<style lang="scss" scoped>
.operation {
  text-align: right
}
.image-upload-tip {
  font-size: 12px;
  color: #7a869e;
}
.course-coverUrl-wrapper {
  position: relative;
  width: 708px;
  .course-coverUrl {
    width: 708px;
  }

  .course-list-page-image {
    width: 318px;
  }

  .icon-remove-image {
    position: absolute;
    right: -15px;
    top: 0;
  }
}
</style>
